import { render } from "./MedicarePayorNew.vue?vue&type=template&id=dedb2b66&ts=true"
import script from "./MedicarePayorNew.ts?vue&type=script&lang=ts&external"
export * from "./MedicarePayorNew.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__